<template>
  <el-dialog title="编辑区域信息"
             :visible.sync="visible"
             width="400px"
             @closed="handleClose"
             :close-on-press-escape="false">
    <el-form status-icon
             :model="codeInfo"
             :rules="rules"
             ref="ruleForm"
             label-width="85px">
      <template v-if="codeInfo.level > 1">
        <el-form-item label="省份:">{{codeInfo.provinceName}}【{{codeInfo.provinceCode}}】</el-form-item>
        <el-form-item label="城市:"
                      v-if="codeInfo.level > 2">{{codeInfo.cityName}}【{{codeInfo.cityCode}}】</el-form-item>
      </template>
      <el-form-item label="区域编码:">{{codeInfo.areaCode}}</el-form-item>
      <el-form-item label="区域名称:"
                    prop="areaName">
        <el-input v-model="codeInfo.areaName"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">提 交</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'area-edit-modal',
  components: {},
  props: {
    callback: Function
  },
  data () {
    return {
      loading: false,
      visible: false,
      codeInfo: {
        areaCode: '',
        areaName: ''
      },
      rules: {
        areaCode: [
          { required: true, pattern: /^[0-9]{6}$/, message: '请输入6位编码', trigger: 'blur' }
        ],
        areaName: [
          { required: true, message: '请输入区域名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal () {
      this.visible = !this.visible
    },
    handleClose () {
      this.codeInfo = {
        areaCode: '',
        areaName: ''
      }
    },
    init (row) {
      this.codeInfo = {
        ...this.codeInfo,
        ...row
      }
      this.toggleModal()
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`delivery/updatearea`, {
            payload: {
              areaCode: this.codeInfo.areaCode,
              areaName: this.codeInfo.areaName
            },
            success: (res) => {
              this.loading = false
              this.toggleModal()
              let value = []
              if (this.codeInfo.level === 2) {
                value = [this.codeInfo.provinceCode, this.codeInfo.cityCode, this.codeInfo.children[0].areaCode]
              }
              if (this.codeInfo.level === 3) {
                value = [this.codeInfo.provinceCode, this.codeInfo.cityCode, this.codeInfo.areaCode]
              }
              this.callback && this.callback(value)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
